import './App.css';
import Home from './components/Home';
import Header from './components/Header';

function App() {
  return (
    <>
      <Header />
      <div className="App">
        <Home />
      </div>
    </>
  );
}

export default App;
